import { render, staticRenderFns } from "./HotelOffers.vue?vue&type=template&id=0d47cf47&scoped=true"
import script from "./HotelOffers.vue?vue&type=script&lang=js"
export * from "./HotelOffers.vue?vue&type=script&lang=js"
import style0 from "./HotelOffers.vue?vue&type=style&index=0&id=0d47cf47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47cf47",
  null
  
)

export default component.exports